import React, { useState, useEffect, useContext } from 'react';
import { getStorage, ref, uploadBytes, getDownloadURL } from 'firebase/storage';
import { PersonContext } from '../providers/Person.jsx';

const Images = ({ images, setImages }) => {

    const [uploading, setUploading] = useState(false);
    const { app } = useContext(PersonContext);

    const upload = async (file) => {
        setUploading(true);
        const storage = getStorage(app);

        const name = new Date().getTime();
        console.log(storage)
        const storageRef = ref(storage, 'images/' + name + '.' + file.name.split('.').pop());
        await uploadBytes(storageRef, file);
        const url = await getDownloadURL(storageRef);

        setImages([...(images || []), url]);
        setUploading(false);
    }

    return <div style={{ background: "White", border: "1px solid #ccc", borderRadius: 4, boxSizing: "border-box", width: "100%", padding: 4 }}>

        {uploading && <i className="fas fa-spinner fa-spin"></i>}

        {!uploading && <div style={{ display: "flex", flexDirection: "row", flexWrap: "wrap", gap: 4, marginBottom: 4 }}>
            {images?.map((image, i) => <div key={i} style={{ display: "flex", padding: 4, border: "1px solid black" }}>
                <i className="fas fa-times" style={{ cursor: "pointer", marginRight: 4 }} onClick={() => setImages(images.filter((img, j) => i !== j))}></i>
                <img src={image} style={{ width: 40, height: 40, objectFit: "cover" }} />
            </div>)}
        </div>}

        <input type="file" onChange={e => upload(e.target.files[0])} />

    </div>;

}

export default Images;